import Randomizer from "../../../../src/docs/components/randomizer";
import Clientrandomizer from "../../../../src/docs/components/clientrandomizer";
import Zoom from 'react-reveal/Zoom'; // Importing Zoom effect

import eccles from "../../../../src/docs/assets/sponsors/eccles.svg";
import zap from "../../../../src/docs/assets/sponsors/zap.svg";
import Ihc from "../../../../src/docs/assets/sponsors/intermountain-white.svg";
import Meldrum from "../../../../src/docs/assets/sponsors/meldrum-foundation-logo.png";
import Nea from "../../../../src/docs/assets/sponsors/nea-logo.svg";
import CorporateSponsors from "../../../../src/docs/assets/corp-sponsor-logos.jpg";
import Marriner from "../../../../src/docs/assets/marriner-eccles-logo.png";
import Promontory from "../../../../src/docs/assets/promontory.jpg";
import * as React from 'react';
export default {
  Randomizer,
  Clientrandomizer,
  Zoom,
  eccles,
  zap,
  Ihc,
  Meldrum,
  Nea,
  CorporateSponsors,
  Marriner,
  Promontory,
  React
};